<template>
  <div>
    <Header @setScroll="setScroll" theme="123"></Header>
    <!-- <div class="banner">
      <div class="word">
        <div style="font-size: 42px;font-family: Source Han Sans CN;color: #FFFFFF;line-height: 46px;">
          政策详情
        </div>
        <div style="font-size: 16px;font-family: Adobe Heiti Std;color: #FFFFFF;line-height: 46px;">
          / Policy Details
        </div>
      </div>
    </div> -->
    <div class="polBody">
      <div class="polTit">{{content.title}}</div>
      <div class="polTime">
        <img src="../../assets/images/time.png" class="timeIcon">
        <span calss="timeText">{{content.publishTime}}</span>
        <span v-if="content.source" class="source">来源：{{content.source}}</span>
      </div>
      <div>
        <div v-html="content.content"></div>
      </div>
    </div>

    <!--页脚-->
    <Footer />
  </div>
</template>

<script>
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  import {
    serverUrl
  } from '@/utils/server.js'
  import {
    articleById
  } from '@/api/api'
  export default {
    data() {
      return {
        scroll: 'home',
        id: '',
        content: {},
        baseUrl: serverUrl.baseURL
      }
    },
    components: {
      Header,
      Footer
    },
    created() {
      this.id = this.$route.query.data
      this.getArticleById()
    },
    methods: {
      setScroll(eId) {
        this.scroll = eId
      },
      getArticleById() {
        articleById({id: this.id}).then(res=> {
          this.content = res.data
        })
      }
    }
  }
</script>

<style scoped>
.banner {
    width: 100%;
    height: 478px;
    background: url(../../assets/images/zczc@2x.png) top center no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
  }
  .word {
    width: 1337px;
    margin: 100px auto 0;
  }
.policyDetailsPage {
  padding-top: 120px;
}
.polBody{
  width: 1300px;
  margin: 0 auto;
  padding-top: 150px;
}
.polTit{
  font-size: 38px;
  font-family: PingFangSC-Medium, PingFang SC;
  color: #36444D;
  line-height: 45px;
  text-align: left;
}
.polTime{
  display: flex;
  align-items: center;
  margin: 0 auto;
  padding: 15px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #767D8A;line-height: 22px;
}

.source{
  padding-left: 20px;
}
.timeIcon{
  width: 20px;
  height: 20px;
  margin-right: 10px;
}



</style>



// WEBPACK FOOTER //
// src/views/policy/PolicyDetails.vue